<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放，选择正确答案
        </el-col>
        <el-col :span="24" class="imgStyle" align="left" :style="{height:heart.questionDto.detailInfo.audioUrl? 'calc( 100% - 55px )':''}">
            <img class="imgStyleUrl" v-if="heart.questionDto.detailInfo.questionImgUrl" v-viewer :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
            <div style="clear: both;"></div>
            <div class="optionsHaveValue" :style="{height:heart.questionDto.detailInfo.questionImgUrl?'80%':''}">
                <el-input v-model='item.fillBlankVal' v-for="(item,i) in forInput" :key="i" @keyup.native="outputFillBlankVal" @change="changeTest" :placeholder="'请输入'+Number(i+1)" class="tkStyle"></el-input>
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"fillBlanks",
        props: {
            sonData: Object,
            allAnswer:Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal:[],
                timeHer:'',
                advancedRadio:'',
                plays:0,
                forInput:[],
                valueComple:'',
                answerType:null,
            }
        },
        components:{
            audioStyle
        },
        watch: {
            'valueComple':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            }
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal = []
                this.plays = utils.mottoClone(this.heart.audioPlayTime)

                this.forInput = []
                this.heart.questionDto.detailInfo.blankList.forEach((ele,index) => {
                    this.forInput.push({
                        fillBlankVal:'',
                    })
                });

                if(this.allAnswer){
                    this.answerType = this.allAnswer.obj.answerType
                    if(this.allAnswer.obj.fillBlankVal){
                        if(this.allAnswer.obj.fillBlankVal.length>0){
                            this.allAnswer.obj.fillBlankVal.split('#@#').forEach((son,i) => {
                                this.forInput[i].fillBlankVal = son==' '? '':son
                            });
                            this.forInput.forEach((son,i) => {
                                this.valueComple += i==0? (son.fillBlankVal? son.fillBlankVal:' '):'#@#'+(son.fillBlankVal? son.fillBlankVal:' ')
                            });
                        }
                        this.plays = this.allAnswer.playss
                    }
                }
            })
        },
        methods:{
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            yesNotProblem(){
                let fleg = false
                this.forInput.forEach((son,i) => {
                    if(son.fillBlankVal){
                        fleg = true;
                        return 
                    }
                });
                if(fleg) return true
                return false
            },
            // 数据转化为 #@#
            outputFillBlankVal(){
                this.valueComple = ''
                let haveContent = true
                this.forInput.forEach((son,i) => {
                    if(son.fillBlankVal&&haveContent) haveContent = false
                    this.valueComple += i==0? (son.fillBlankVal? son.fillBlankVal:' '):'#@#'+(son.fillBlankVal? son.fillBlankVal:' ')
                });
                if(haveContent)
                this.valueComple = ''
            },
            changeTest(){
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 10px 18px;
            .imgStyleUrl{
                height: 20%;
                max-width: 85%;
            }
            .optionsHaveValue{
                height: 100%;
                overflow-y: auto;
                .tkStyle{
                    margin: 5px 0;
                }
            }
        }
    }
</style>
<style>
    .styleCent .el-radio__inner{
        height: 18px;
        width: 18px;
    }
    .textAlign .tableimg{
        height: 37px;
        max-height: 37px !important;
        width: 80% !important;

        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .textAlign .tableimg img{
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        /* right: 0; */
        bottom: 0;
        left: 0;
        display: block;
        margin: auto 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/fillBlanks.vue